/**
 * RTWO Cryptography & Identity Engine — KMS Key Provider (Scaffold)
 */

import { ScaffoldKeyProvider } from './scaffold-key-provider';

export class KmsKeyProvider extends ScaffoldKeyProvider {
  readonly providerId = 'kms-key-provider';
  readonly providerName = 'KMS Key Provider';
  readonly providerType = 'kms' as const;
  readonly scaffoldMessage =
    'KMS key provider scaffold. Key management service connection not implemented — cryptographic operations unavailable.';
}
